import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface StatusHistoryModalProps {
  open: boolean;
  onClose: () => void;
  list: StatusItem[];
}

interface StatusItem {
  status: string;
  date: string;
  completed: boolean;
}

const StatusHistoryModal: React.FC<StatusHistoryModalProps> = ({
  open,
  onClose,
  list,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          bgcolor: "#fff",
          height: "70vh",
        },
      }}
    >
      <DialogTitle
        sx={{
          bgcolor: "#0A0C33",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 2,
          position: "relative",
        }}
      >
        <Typography variant="h6" sx={{ textAlign: "center" }}>
          Histórico de Status
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            color: "white",
            border: "1px solid white",
            position: "absolute",
            right: 16,
            top: "50%",
            transform: "translateY(-50%)",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ mt: 2, overflowY: "auto" }}>
        {!list || list.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              height: "100%",
              mt: 4,
            }}
          >
            <Typography variant="body1" color="text.secondary">
              Nenhum status disponível.
            </Typography>
          </Box>
        ) : (
          <Box
            sx={{
              position: "relative",
              m: "32px 0 48px 38px",
            }}
          >
            {list.map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                  minHeight: index === 0 ? 48 : 58,
                }}
              >
                {index < list.length - 1 && (
                  <Box
                    sx={{
                      position: "absolute",
                      left: 8,
                      top: 16,
                      bottom: "-16px",
                      width: 2,
                      backgroundColor:
                        list[index].completed && list[index + 1].completed
                          ? "#A5EB17"
                          : "#0A0C33",
                      zIndex: 1,
                      height: `calc(100% + 8px)`,
                    }}
                  />
                )}
                <Box
                  sx={{
                    width: 16,
                    height: 16,
                    borderRadius: "50%",
                    bgcolor: item.completed ? "#A5EB17" : "#0A0C33",
                    position: "absolute",
                    left: 0,
                    zIndex: 2,
                  }}
                />
                <Box
                  sx={{
                    ml: 4,
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                >
                  <Typography variant="body1">{item.status}</Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      fontStyle:
                        item.date === "sem previsão" ? "italic" : "normal",
                    }}
                  >
                    ({item.date})
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default StatusHistoryModal;
